// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fxxm","badges":"styles_badges__3FjgF"};